import styles from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Base/Columns/TwoColumns.css';

export const prototypeName = 'Servicebund.RodeoSteakDe:Base.Columns.TwoColumns';
export {styles};